import { cn } from '@/lib/utils';
import { ReactNode } from 'react';
type CardProps = React.ComponentProps<'div'> & {
  children: ReactNode;
  className?: string;
  variant?: 'default' | 'secondary';
};

export default function Card({
  children,
  className,
  variant = 'default',
  ...props
}: CardProps) {
  const commonStyles = cn(
    'w-full h-full rounded-lg p-4 border border-[#E5E7EB]',
    'dark:bg-gray-800 dark:text-white dark:border-gray-700'
  );

  const variantStyles = {
    default: 'bg-white',
    secondary: 'bg-[#F9FAFB]',
  };

  return (
    <div
      className={cn(commonStyles, variantStyles[variant], className)}
      {...props}
    >
      {children}
    </div>
  );
}
